/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {

                $(document).ready(function () {
                    $(document).on("scroll", onScroll);

                    //smoothscroll
                    $('a[href*="#"]').on('click', function (e) {


                        var offset;
                        if ( $('nav.navbar.navbar-default').hasClass('navbar-fixed-top') ) {
                            offset = 80;
                        } else {
                            offset = 160;
                        }

                        e.preventDefault();
                        $(document).off("scroll");

                        $('a').each(function () {
                            $(this).removeClass('active');
                        })
                        $(this).addClass('active');

                        var target = this.hash,
                            menu = target;
                        $target = $(target);
                        $('html, body').stop().animate({
                            'scrollTop': $target.offset().top - offset
                        }, 1000, 'swing', function () {
                            window.location.hash = target;
                            $('#bs-navbar-collapse').removeClass('in');
                            $(document).on("scroll", onScroll);
                        });
                    });
                });

                function onScroll(event){
                    var scrollPos = $(document).scrollTop();

                    if (scrollPos >= 300) {
                        $('.navbar').removeClass('animated slideInUp');
                        $('.navbar').addClass('navbar-fixed-top animated slideInDown');
                        $('#bs-navbar-collapse').removeClass('in');
                    } else {
                        $('.navbar').addClass('animated slideInUp');
                        $('#bs-navbar-collapse').removeClass('in');
                        $('.navbar').removeClass('navbar-fixed-top animated slideInDown');
                    }

                    $('#bs-navbar-collapse ul#menu-main-menu > li > a:first-child').each(function () {
                        var currLink = $(this);
                        var refElement = $(currLink.attr("href").match(/#(\w+)(?!\w)/g).toString());
                        if (refElement.position().top-80 <= scrollPos && refElement.position().top-80 + refElement.height() > scrollPos) {
                            $('#bs-navbar-collapse ul#menu-main-menu > li > a:first-child').removeClass("active");
                            currLink.addClass("active");
                            $('#bs-navbar-collapse').removeClass('in');
                        }
                        else{
                            currLink.removeClass("active");
                            $('#bs-navbar-collapse').removeClass('in');
                        }
                    });
                }


            },
            finalize: function () {

            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        },
        'single': {
            init: function () {
                $(document).ready(function () {
                    function onScroll(event){
                        var scrollPos = $(document).scrollTop();

                        if (scrollPos >= 300) {
                            $('.navbar').removeClass('animated slideInUp');
                            $('.navbar').addClass('navbar-fixed-top animated slideInDown');
                        } else {
                            $('.navbar').addClass('animated slideInUp');
                            $('.navbar').removeClass('navbar-fixed-top animated slideInDown');
                        }

                        $('#bs-navbar-collapse ul#menu-main-menu > li > a:first-child').each(function () {
                            var currLink = $(this);
                            var refElement = $(currLink.attr("href").match(/#(\w+)(?!\w)/g).toString());
                            if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
                                $('#bs-navbar-collapse ul#menu-main-menu > li > a:first-child').removeClass("active");
                                currLink.addClass("active");
                                $('#bs-navbar-collapse').removeClass('in');
                            }
                            else{
                                currLink.removeClass("active");
                                $('#bs-navbar-collapse').removeClass('in');
                            }
                        });
                    }
                    $(document).on("scroll", onScroll);

                    //smoothscroll
                    $('a[href*="#"]').on('click', function (e) {
                        e.preventDefault();
                        $(document).off("scroll");

                        $('a').each(function () {
                            $(this).removeClass('active');
                        });
                        $(this).addClass('active');

                        var target = this,
                            menu = target;
                        $target = $(target);
                        $('html, body').stop().animate({
                            'scrollTop': $target.offset().top - 70
                        }, 1000, 'swing', function () {
                            window.location = target;
                            $(document).on("scroll", onScroll);
                        });
                    });


                    if ($(window).width() < 768) {
                        $('.contact .container').removeClass('container');
                        $('.contact .row').removeClass('row');
                        $('.contact .col-md-12').removeClass('col-md-12');
                        $('.contact .contact-form').css("margin", "initial");
                        $('.main-content').removeClass('container-fluid');
                        $('.menu-item-has-children').removeClass('dropdown');
                        $('.menu-item-has-children > a > span').css("display", "none");
                    }

                    $(window).resize(function () {
                        if ($(window).width() < 768) {
                            $('.contact-container').removeClass('container');
                            $('.contact-row').removeClass('row');
                            $('.contact-col').removeClass('col-md-12');
                            $('.main-content').removeClass('container-fluid');
                            $('.menu-item-has-children').removeClass('dropdown');
                            $('.menu-item-has-children > a > span').css("display", "none");
                            $('.contact .contact-form').css("margin", "initial");
                        } else {
                            $('.contact-container').addClass('container');
                            $('.contact-row').addClass('row');
                            $('.contact-col').addClass('col-md-12');
                            $('.main-content').addClass('container-fluid');
                            $('.menu-item-has-children').addClass('dropdown');
                            $('#bs-navbar-collapse').removeClass('in');
                            $('.menu-item-has-children > a > span').css("display", "inline-block");
                            $('.contact .contact-form').css("margin", "0 15px 60px");
                        }
                    });


                });

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
